module.exports = __webpack_public_path__ + "static/08-6c2d4c6af3d53b793d206fde5588537a.jpg";